/**
 * @module ArrayHelper
 */

/**
 * Convenience function to return an array of numItems-long random items from the specified array.
 *
 * @param {Array} array - Array from which to shuffle and return random elements.
 * @param {number} numItems - Number of items to return in the new array.
 *
 * @returns {Array} Array of randomly sorted items from the original array.
 */
function getRandomArrayItems(array, numItems) {
  if (!array?.length || !Array.isArray(array)) {
    return [];
  }
  const finalNumItems = numItems > array.length ? array.length : numItems;
  const shuffledArray = [...array].sort(() => 0.5 - Math.random());
  return shuffledArray.slice(0, finalNumItems);
}

module.exports = {
  getRandomArrayItems,
};
